import React, { useState, useEffect, useRef } from 'react';
import { Formik, Form } from 'formik';
import { useHistory } from 'react-router';
import { useLocation } from 'react-router-dom';
import * as Yup from 'yup';
import Box from '@material-ui/core/Box';
import { LOGOUT } from 'ConstComponents';
import {
    Select as SENDER_SELECT,
    SelectBankList as BANK_LIST
} from 'Components/Api/PaysprintDMTAPI';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import { Container, Grid, Paper, Hidden, MenuItem } from '@material-ui/core';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import {
    PLEASE_PROVIDE_VALID,
    MONEY_TRANSFER_CODE,
    PLEASE_SELECT_VALID
} from 'Components/Helper/Messages';
import { CONSUMER_NUMBER_FONT_SIZE } from 'Config';
import BeneficiaryList from './BeneficiaryList';
import { Last10Report } from 'Pages/InnerPages/Report/Last10Report';
import { PrimaryButton } from 'Components/Inputes/CustomButton';
import SearchIcon from 'Components/SvgButtons/SearchIcon';
import AutoSubmitMobileForSender from 'Components/Helper/AutoSubmitMobileForSender';
import AddbeneficiaryIcon from 'Components/SvgButtons/AddbeneficiaryIcon';
import HOCLoader from 'Components/Loader/HOCLoader';
import { MaterialSelect } from 'Components/Inputes/FormikMaterialSelect';

const CustomContainer = HOCLoader(Container);

export const SenderSearch = ({ ActiveDMTName }) => {
    const formRef = useRef();
    const classes = commonStyle();
    const history = useHistory();
    const [senderNo, setSenderNo] = useState('');
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [Bank, setBank] = useState([]);
    const [addBeneficiary, setAddBeneficiary] = useState('none');
    const [serviceCode, setServiceCode] = useState(MONEY_TRANSFER_CODE);
    const [consumerNumberFontSize, setConsumerNumberFontSize] = useState('');
    async function fetchConsumerNumberFontSize() {
        setConsumerNumberFontSize(await CONSUMER_NUMBER_FONT_SIZE());
    }
    const location = useLocation();
    const Mobile = location?.state?.Mobile;
    const Pipe = location?.state?.Pipe;
    const [formObject, setFormObject] = useState({
        Mobile: Mobile,
        Pipe: Pipe || '',
        Name: '',
        SenderID: '',
        RemainingLimit: '',
        Consumed: '',
        isAddBeneficiary: false
    });
    useEffect(() => {
        GetBankTypeList();
        fetchConsumerNumberFontSize();
        select();
    }, [Mobile, Pipe]);

    useEffect(() => {
        if (Pipe) {
            setFormObject((prev) => ({
                ...prev,
                Pipe: Pipe
            }));
        }
    }, [Pipe]);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (formRef === undefined) return;

            if (!formRef.current) return;

            if (formRef.current.values === undefined) return;

            if (formRef.current.values.Mobile === undefined) return;

            if (formRef.current.values.Mobile.length !== 10) return;

            formRef.current.handleSubmit();
        }, 500);
        return () => clearTimeout(timer);
    }, []);

    const GetBankTypeList = async () => {
        var request = {
            ID: 0
        };
        var json = JSON.stringify(request);

        const response = await BANK_LIST(json);

        setLoading(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setResponseMessage(response.data);
            setIsError(true);
        }

        var data = JSON.parse(response.data);
        setBank(data);
        // setFormObject({
        //     ...formObject,
        //     //Pipe: data[0].BankName
        //     Pipe: data.length > 0 ? data[0].BankName : ''
        // });

        if (!formObject.Pipe) {
            setFormObject((prevState) => ({
                ...prevState,
                Pipe: data.length > 0 ? data[0].BankName : ''
            }));
        }
    };
    const BankList = Bank.map((item) => (
        <MenuItem key={item.ID} value={item.BankName}>
            {item.BankName}
        </MenuItem>
    ));

    const select = async () => {
              setLoading(false);
              if (Mobile === undefined) {
                  return;
              }
              setFormObject((prevFormObject) => ({
                  ...prevFormObject,
                  Mobile: Mobile,
                  Pipe: Pipe,
                  Name: '',
                  SenderID: '',
                  RemainingLimit: ''
              }));
              // setFormObject({
              //     ...formObject,
              //     Mobile: Mobile,
              //     Pipe: Pipe,
              //     Name: '',
              //     SenderID: '',
              //     RemainingLimit: ''
              // });
          };;

    const submithandle = async (values, { setSubmitting, resetForm }) => {
        // let op = Bank.filter((o) => o.Pipe === values.Pipe);
        // values.Name = op[0].Name;
        setFormObject({
            ...formObject,
            Mobile: values.Mobile,
            Pipe: values.Pipe,
            Name: '',
            SenderID: '',
            Consumed: '',
            RemainingLimit: ''
        });
        setServiceCode('');
        setSenderNo('');
        setResponseMessage('');
        var requestObj = JSON.stringify(values);
        setIsError(false);

        if (values.isAddBeneficiary) {
            var param = {
                Mobile: values.Mobile,
                SenderName: values.Name,
                Pipe: values.Pipe
            };
            history.push('/PS_BeneficiaryAdd', param);
            return;
        }
        setLoading(true);
        var response = await SENDER_SELECT(requestObj);
        setLoading(false);
        if (!response.isAuthorized) LOGOUT();

        setServiceCode(MONEY_TRANSFER_CODE);
        setSeverity('success');

        if (!response.status) {
            setSeverity('error');
            setIsError(true);
            var data = JSON.parse(response.data);
            setResponseMessage(data.Message);
            if (
                data.Message ===
                'Kindly register the remitter. OTP has been sent to the remitter mobile number.'
            ) {
                let paramSender = {
                    Mobile: values.Mobile,
                    StateResp: data.StateResp,
                    EKYCID: data.KYCID
                };
                history.push('/PS_SenderAdd', paramSender);
                return;
            }

            if (data.Message === 'Please do remitter e-kyc.') {
                let param = {
                    Mobile: values.Mobile,
                    State: data.StateResp,
                    Pipe: values.Pipe
                };
                history.push('/PS_SenderAuthentication', param);
                return;
            }

            if (
                data.Message === 'Please validate your aadhaar number.' ||
                data.Discription === 'Aadhar Verification'
            ) {
                let param1 = {
                    Mobile: values.Mobile,
                    Pipe: values.Pipe
                };
                history.push('/PS_SenderAadharVerifyBank2', param1);
                return;
            }

            if (
                data.Message ===
                'Your KYC is not approved, please contact to customer care'
            ) {
                history.push('/KYC/Upload');
                return;
            }
            return;
        }

        var data = JSON.parse(response.data);

        if (data.Message === 'Kindly register the remitter.') {
            setAddBeneficiary('inline');
            setFormObject({
                Mobile: data.Mobile,
                Name: data.Name,
                SenderID: data.SenderID,
                Consumed: data.Consumed,
                RemainingLimit: data.RemainingLimitBank,
                Pipe: values.Pipe,
                isAddBeneficiary: false
            });
            setSenderNo(data.Mobile);
        } 
        setAddBeneficiary('inline');
        setFormObject({
            Mobile: data.Mobile,
            Name: data.Name,
            SenderID: data.SenderID,
            Consumed: data.Consumed,
            RemainingLimit: data.RemainingLimitBank,
            Pipe: values.Pipe,
            isAddBeneficiary: false
        });

        setSenderNo(data.Mobile);
    };

    const FormValidationSchema = Yup.object({
        Mobile: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'mobile')
            .length(10, PLEASE_PROVIDE_VALID + 'mobile'),
        Pipe: Yup.string()
            .notOneOf(['0'], PLEASE_SELECT_VALID + 'bank type')
            .required(PLEASE_SELECT_VALID + 'bank type')
    });

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                innerRef={formRef}
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={submithandle}
                resetForm={formObject}
            >
                {({ setFieldValue, handleSubmit }) => {
                    return (
                        <Form>
                            <AutoSubmitMobileForSender />
                            <Grid item xs={12}>
                                <Paper className={classes.PaperStyle}>
                                    <Grid container spacing={2}>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialSelect
                                                label="Bank"
                                                name="Pipe"
                                                placeholder="Select Bank"
                                                value={formObject.Pipe}
                                                onChange={(e) =>
                                                    setFormObject({
                                                        ...formObject,
                                                        Pipe: e.target.value
                                                    })
                                                }
                                                autoFocus
                                            >
                                                {BankList}
                                            </MaterialSelect>
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialNumberField
                                                font_size={
                                                    consumerNumberFontSize
                                                }
                                                label="Mobile"
                                                name="Mobile"
                                                type="Mobile"
                                                length={10}
                                                placeholder="Mobile"
                                                typed_length={1}
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <PrimaryButton
                                                title="Search"
                                                disabled={loading}
                                                endIcon={<SearchIcon />}
                                                onClick={(e) => {
                                                    setFieldValue(
                                                        'isAddBeneficiary',
                                                        false
                                                    );
                                                    setAddBeneficiary('none');
                                                    handleSubmit(e);
                                                }}
                                            >
                                                Search
                                            </PrimaryButton>
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <Box display={addBeneficiary}>
                                                <PrimaryButton
                                                    title="Add Beneficiary"
                                                    disabled={loading}
                                                    endIcon={
                                                        <AddbeneficiaryIcon />
                                                    }
                                                    onClick={(e) => {
                                                        setFieldValue(
                                                            'isAddBeneficiary',
                                                            true
                                                        );
                                                        handleSubmit(e);
                                                    }}
                                                >
                                                    Add Beneficiary
                                                </PrimaryButton>
                                            </Box>
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="Remaining Limit"
                                                name="RemainingLimit"
                                                type="text"
                                                readOnly={true}
                                                placeholder="Remaining Limit"
                                            />
                                            <Hidden xsUp>
                                                <MaterialTextField
                                                    label="SenderID"
                                                    name="SenderID"
                                                    type="text"
                                                    readOnly={true}
                                                    placeholder="SenderID"
                                                />
                                            </Hidden>
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="Consumed"
                                                name="Consumed"
                                                type="text"
                                                readOnly={true}
                                                placeholder="Consumed"
                                            />
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                        </Form>
                    );
                }}
            </Formik>

            <BeneficiaryList
                senderNo={senderNo}
                ActiveDMTName={ActiveDMTName}
                senderName={formObject.Name}
                pipe={formObject.Pipe}
                setIsError={(value) => {
                    setIsError(value);
                }}
                setSeverity={(value) => {
                    setSeverity(value);
                }}
                setLoading={(value) => {
                    setLoading(value);
                }}
                setResponseMessage={(value) => {
                    setResponseMessage(value);
                }}
                formRef={formRef}
            />

            <Last10Report
                ServiceID={serviceCode}
                setIsError={(value) => {
                    setIsError(value);
                }}
                setSeverity={(value) => {
                    setSeverity(value);
                }}
                setLoading={(value) => {
                    setLoading(value);
                }}
                setResponseMessage={(value) => {
                    setResponseMessage(value);
                }}
                formRef={formRef}
            />
        </CustomContainer>
    );
};
